module.exports = __webpack_public_path__ + "a74ff00c7fb7de3e16a8b0ecc7562203.png";